import { useLocation } from "react-router-dom";
// @mui
import { Box, BoxProps } from "@mui/material";
// hooks
import useResponsive from "../../../../minimals/hooks/useResponsive";
// config
import { HEADER, NAV } from "../../../../minimals/config-global";
// components
import { useSettingsContext } from "../../../../minimals/components/settings";

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === "horizontal";

  const isNavMini = themeLayout === "mini";

  const isDesktop = useResponsive("up", "lg");

  // Funding packages list uses tighter vertical padding so its table can fill the screen
  const isFundingPackages = useLocation().pathname.startsWith("/funding-packages");

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          pt: `${HEADER.H_MOBILE + SPACING}px`,
          pb: `${HEADER.H_MOBILE + SPACING}px`,
          ...(isDesktop && {
            px: 2,
            pt: isFundingPackages ? "80px" : `${HEADER.H_DASHBOARD_DESKTOP + 80}px`,
            pb: isFundingPackages ? "24px" : `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`
          })
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`
          })
        }),
        ...sx
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
